import mixins from './mixins';
import palette from './palette';
import constants from './constants';
import overrides from './overrides';
import typography from './typography';
export default {
  palette: palette,
  overrides: overrides,
  mixins: mixins,
  constants: constants,
  unityTypography: typography,
  typography: {
    useNextVariants: true
  }
};